export default __webpack_public_path__ + "static/media/6osica.82c1e659.webp";